import axios from "axios";

export const API_BASE = "https://theaimatters.com/api";

export const apiClient = axios.create({
  baseURL: API_BASE,
  headers: {
    "Content-Type": "application/json",
  },
});